import { FieldTemplateProps } from '@rjsf/utils';
import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

/** Whether a field holds an answer: not undefined, not an empty string, not an empty list. */
function isAnswered(value: unknown) {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  return !(Array.isArray(value) && value.length === 0);
}

/**
 * The characterisation forms' field, drawn the design's way: its label, and for a required field a small tag —
 * "Required" in amber until it is answered, then "Done" in green, a pill set apart from the label — instead of a red asterisk. The rest is RJSF's.
 */
export function CharacterisationFieldTemplate({
  id,
  classNames,
  style,
  label,
  displayLabel,
  required,
  hidden,
  description,
  children,
  errors,
  help,
  formData,
}: FieldTemplateProps) {
  const { t } = useTranslation();
  if (hidden) {
    return <div className="hidden">{children}</div>;
  }
  const answered = isAnswered(formData);
  return (
    <div className={classNames} style={style}>
      {displayLabel && label && (
        <label htmlFor={id} className="control-label flex items-center gap-2">
          <span>{label}</span>
          {required && (
            <span
              className={classnames(
                'rounded-full px-[7px] text-[10.5px] font-semibold normal-case leading-[18px]',
                answered ? 'bg-dl-success/15 text-dl-success' : 'bg-dl-warning/15 text-dl-warning'
              )}
            >
              {answered ? t('Done') : t('Required')}
            </span>
          )}
        </label>
      )}
      {displayLabel && description}
      {children}
      {errors}
      {help}
    </div>
  );
}

export const characterisationTemplates = {
  FieldTemplate: CharacterisationFieldTemplate,
};
